<template>
  <section
    id="cover"
    class="te-bg-webdesign-jobs-image flex h-[270px] flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
  >
    <h1 class="te-title-mentor-recruits mb-5 font-bold drop-shadow-[0_1px_2px_rgba(0,0,0,.3)]">
      Webデザイン<br class="lg:hidden">メンター（講師）の募集
    </h1>
  </section>
</template>

<style scoped>
.te-bg-webdesign-jobs-image {
  background-image: url('~/assets/images/Te/TeJob/Webdesign/Cover/cover-mentor-webdesign.jpg');
}

/* // メンター募集ページ用タイトル */
.te-title-mentor-recruits {
  font-size: 1.25rem;
  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
}
</style>
